import { Crumbs } from "molecules/Breadcrumbs";
import { TitleHeading } from "molecules/TitleHeading";
import React, { useEffect, useState } from "react";
import { SmallHadding } from "molecules/SmallHeadding";
import { DetailBox } from "molecules/DetailBox";
import { ArrowButton } from "molecules/ArrowButton";
import ItemSlider from "./itemSlider";
import styled from "styled-components";
import { MultiSelect } from "primereact/multiselect";
import ItemSliderProjects from "./ItemSliderProjects";
import { InnerBanner } from "container/InnerpageBanner/index2";
import DropdownTable from "component/DropdownTable/DropdownTable";
import Modal from "react-modal";
import { SectionBorder } from "molecules/SectionBorder";
import { useSelector, RootStateOrAny } from "react-redux";
import { useSearchParams } from "react-router-dom";

const CustDropdown = styled(MultiSelect)`
  border: 1px solid rgb(200, 32, 39);
  background: transparent;
  border-radius: 0;
  font-weight: 500;
`;

export const ProjectListing = () => {
  const [searchParams] = useSearchParams();
  const deepLinkProjectId = searchParams.get("projectId") || "";
  const deepLinkLocation = searchParams.get("location") || "";
  const { data, loading, error } = useSelector((state) => state.projects);
  const { data: dashboardData } = useSelector((state) => state.dashboard);
  console.log("slidingData", data);
  const [selectedProjectTypes, setSelectedProjectTypes] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);

  const projects = data?.projects || [];
  const uniqSorted = (values) =>
    [...new Set(values.filter(Boolean).map((v) => String(v).trim()).filter(Boolean))].sort(
      (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" })
    );

  const projectTypeOptions = uniqSorted(projects.map((p) => p.project_type)).map(
    (name, idx) => ({ name, code: `pt_${idx}` })
  );
  const locationOptions = uniqSorted(projects.map((p) => p.location)).map(
    (name, idx) => ({ name, code: `loc_${idx}` })
  );
  const serviceOptions = uniqSorted(projects.map((p) => p.service)).map(
    (name, idx) => ({ name, code: `srv_${idx}` })
  );
  const yearOptions = uniqSorted(projects.map((p) => p.year)).map((name, idx) => ({
    name,
    code: `yr_${idx}`,
  }));

  useEffect(() => {
    const loc = deepLinkLocation.trim();
    if (!loc) return;
    setSelectedLocations([loc]);
  }, [deepLinkLocation, projects.length]);

  const filteredProjects = projects.filter((p) => {
    const typeOk =
      selectedProjectTypes.length === 0 ||
      selectedProjectTypes.includes(String(p.project_type || "").trim());
    const locationOk =
      selectedLocations.length === 0 ||
      selectedLocations.includes(String(p.location || "").trim());
    const serviceOk =
      selectedServices.length === 0 ||
      selectedServices.includes(String(p.service || "").trim());
    const yearOk =
      selectedYears.length === 0 ||
      selectedYears.includes(String(p.year || "").trim());
    return typeOk && locationOk && serviceOk && yearOk;
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  };
  const customStylesForMobile = {
    content: {
      position: "absolute",
      top: 150,
      right: 0, // right: "100%",
      // right: "auto",
      bottom: 0,
      paddingTop: 0,
      marginTop: 0,
      // transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "250px",
      maxHeight: "100vh",
      overflowY: "auto",
      border: "none !importent", // Remove the default border

      // backgroundColor: 'red'

      // backgroundColor: 'red'
    },
  };

  const customStyles = {
    content: {
      top: "50%", // Center it vertically
      right: "0", // Align to the right
      left: "auto", // Remove any left offset
      bottom: "0", // Make it stretch to the bottom if needed
      transform: "translateY(-50%)", // Center it vertically
      width: "40%", // Adjust the width, you can change this percentage based on your needs
      maxWidth: "1000px", // Ensures that it doesn’t go over a certain width
      height: "100vh", // Full height
      padding: "20px", // Adjust padding if necessary
      backgroundColor: "#fff", // Ensure it has a proper background color
      overflowY: "auto", // Allow scrolling if content overflows
      zIndex: 999, // Ensure it’s always on top
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  };

  return (
    <div className="backgroundThm mobileContainer">
      <section style={{}}>
        <div className="container  pl-0 pr-0">
          <Crumbs />

          <div className="container p-0 -mt-1">
            <InnerBanner
              bannertext={dashboardData?.project_listing_description}
              bannerimg={dashboardData?.project_listing_image}
              innertitle={dashboardData?.project_listing_title || "Project Listings"}
            />
          </div>

          <div
            className="flex align-items-center my-2 showInMobile"
            style={{
              // borderBottom: "2px solid rgb(200, 32, 39)",
              width: "100px",
              paddingLeft: "1rem",
            }}
          >
            <div className="showInMobile">
              <i className="pi pi-sliders-h mr-2 "></i>
            </div>
            <span className="text-lg s-25 showInMobile" onClick={openModal}>
              Filter
            </span>
          </div>
          <div className="showInMobile container px-0 py-0 my-0">
            <SectionBorder />
          </div>
        </div>
      </section>

      <section className="section-padding py-4 px-0">
        <div className="container  pl-0 pr-0 pt-2 ">
          <div className="grid align-items-center">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div className="lg:col-3 md:col-6 sm:col-12 hideInMobile pl-0">
                <div
                  className="flex align-items-center"
                  style={{
                    borderBottom: "2px solid rgb(200, 32, 39)",
                    width: "100px",
                    paddingLeft: "1rem",
                  }}
                >
                  <i className="pi pi-sliders-h mr-2 "></i>
                  <span className="text-lg s-25">Filter</span>
                </div>
              </div>
              <div
                className="mr-0 insightDropdown"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "20px",
                }}
              >
                <DropdownTable
                  title="Project Type"
                  options={projectTypeOptions}
                  value={selectedProjectTypes}
                  onChange={setSelectedProjectTypes}
                />
                <DropdownTable
                  title="Location"
                  options={locationOptions}
                  value={selectedLocations}
                  onChange={setSelectedLocations}
                />
                <DropdownTable
                  title="Service"
                  options={serviceOptions}
                  value={selectedServices}
                  onChange={setSelectedServices}
                />
                <DropdownTable
                  title="Year"
                  options={yearOptions}
                  value={selectedYears}
                  onChange={setSelectedYears}
                />
              </div>
            </div>

            <div className="lg:col-3 md:col-6 sm:col-12"></div>

            <div className="lg:col-3 md:col-6 sm:col-12"></div>

            <div className="lg:col-3 md:col-6 sm:col-12"></div>

            <div className="lg:col-3 md:col-6 sm:col-12"></div>
          </div>

          <div className="grid mt-0 overflow">
            <div
              className="lg:col-12 md:col-12 sm:col-12 pr-0 pl-0  mt-2"
              data-aos="fade-up"
            >
              {filteredProjects && filteredProjects.length > 0 && (
                <ItemSliderProjects
                  slidingData={filteredProjects}
                  scrollToProjectId={
                    deepLinkProjectId.trim() ? deepLinkProjectId.trim() : undefined
                  }
                />
              )}
              {projects && projects.length > 0 && filteredProjects.length === 0 && (
                <div className="text-center py-5" style={{ color: "#444" }}>
                  No projects match the selected filters.
                </div>
              )}
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesForMobile}
          contentLabel="Project Detail Modal"
          className=" mobileHistoryDiv"
        >
          <div className="col-12 ">
            <div
              className="before-red-border1 "
              style={{
                position: "relative",
                top: "100px",
                zIndex: "9",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
              }}
            >
              <div className="">
                <SectionBorder />
                <div
                  className="flex align-items-center py-0  my-2"
                  style={{
                    // borderBottom: "2px solid rgb(200, 32, 39)",
                    width: "100px",
                    paddingLeft: "1rem",
                  }}
                >
                  <i className="pi pi-sliders-h mr-2 "></i>
                  <span className="text-lg s-25" onClick={openModal}>
                    Filter
                  </span>
                </div>
                <SectionBorder />
              </div>

              <DropdownTable
                title="Project Type"
                options={projectTypeOptions}
                value={selectedProjectTypes}
                onChange={setSelectedProjectTypes}
              />
              <DropdownTable
                title="Location"
                options={locationOptions}
                value={selectedLocations}
                onChange={setSelectedLocations}
              />
              <DropdownTable
                title="Service"
                options={serviceOptions}
                value={selectedServices}
                onChange={setSelectedServices}
              />
              <DropdownTable
                title="Year"
                options={yearOptions}
                value={selectedYears}
                onChange={setSelectedYears}
              />
            </div>
          </div>
        </Modal>
      </section>
    </div>
  );
};
